import React, { useLayoutEffect, useRef } from 'react';
import { Table } from 'react-bootstrap';

// Copies each column's header text onto its body cells as data-label, which the phone layout prints
const labelCells = (table) => {
  const head = table.tHead?.rows[table.tHead.rows.length - 1];
  if (!head) return;
  const labels = [];
  for (const th of head.cells) {
    for (let i = 0; i < th.colSpan; i += 1) labels.push(th.textContent.trim());
  }
  for (const body of table.tBodies) {
    for (const row of body.rows) {
      let column = 0;
      for (const cell of row.cells) {
        const label = labels[column] ?? '';
        if (cell.dataset.label !== label) cell.dataset.label = label;
        column += cell.colSpan;
      }
    }
  }
};

/**
 * A react-bootstrap Table that, on phones, shows each row as a card of labelled fields (styled by
 * .table-stack in index.css). The first column is the card's title, and a cell with colSpan (an
 * expanded detail row or an empty state) spans the card. Labels come from the header cells, so rows
 * need no extra markup. Tablet and desktop render the plain table.
 */
const StackedTable = ({ className = '', ...props }) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const table = ref.current;
    if (!table) return undefined;
    labelCells(table);
    // Rows arrive after loading and headers change text when sorted
    const observer = new MutationObserver(() => labelCells(table));
    observer.observe(table, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, []);

  return <Table ref={ref} className={`table-stack ${className}`} {...props} />;
};

export default StackedTable;
